(function(){
  'use strict';

  function MenuActionsCtrl(mdPanelRef, configFilter, resetFilter) {
    this.panelRef = mdPanelRef;
    this.filter = configFilter;
  }

  MenuActionsCtrl.prototype.search = function (ev, form) {
    form.$submitted = true;
    var self = this;
    if(form.$valid) {
      this.panelRef.config.locals.configFilter = this.filter;
      this.panelRef
        .close('search');
    }
  };

  MenuActionsCtrl.prototype.closeMenu = function (closeReason) {
    if (!this.panelRef) {
      return;
    }
    this.panelRef
      .close(closeReason);
  };

  MenuActionsCtrl.prototype.clearAll = function () {
    this.filter = angular.copy(this.resetFilter);
  };

  angular
  .module('mandaeApp')
  .controller('MenuActionsCtrl', MenuActionsCtrl);

}());